module.exports = __webpack_public_path__ + "static/media/mtto_empaque.d593098d.svg";